module.exports = __webpack_public_path__ + "img/7.f26747e1.jpg";